import * as API from '@/api';
import DEFINES from '@/defines';
import router from '../../router';
import {getField, updateField} from 'vuex-map-fields';
import momentTz from 'moment-timezone';
import i18n from '@/i18n';

//initial state
function initialState () {
  return {
    list: [],
    selected_company_id: null,
    members: null,
    company: null,
    recent_activities: [],
    avail_links: [],
  };
}
const state = initialState ();

// actions

const actions = {
  async create (context, payload) {
    var response = await API.company.create (payload);
    //update companies list once new company created
    await context.dispatch ('list', {});
    return response;
  },

  async get (context, payload) {
    var response = await API.company.get (payload);
    context.commit ('set_company', {
      company: response.company,
    });
    return response.company;
  },

  async delete (context, payload) {
    var response = await API.company.delete (payload);

    //if deleting selected company then reset selected company
    let selected_company_id = context.getters.getSelected;
    if (payload.id == selected_company_id) {
      context.commit ('reset_selected_company');
    }

    return response;
  },

  async update (context, payload) {
    var response = await API.company.update (payload);
    context.commit ('update_company', {
      company: response.company,
    });
    return response;
  },

  async updateFestivalHomePage (context, payload) {
    var response = await API.company.updateFestivalHomePage (payload);
    context.commit ('update_company', {
      company: response.company,
    });
    //set selected company
    context.commit ('set_company', {
      company: response.company,
    });
    return response;
  },
  async updateCookie (context, payload) {
    var response = await API.company.updateCookie (payload);
    context.commit ('update_company', {
      company: response.company,
    });
    //set selected company
    context.commit ('set_company', {
      company: response.company,
    });
    return response;
  },

  async getMembers (context, payload) {
    var response = await API.company.getMembers (payload);
    context.commit ('set_members', {
      members: response.members,
    });
    return response;
  },

  async addMember (context, payload) {
    var response = await API.company.addMember (payload);
    return response;
  },

  async removeMember (context, payload) {
    var response = await API.company.removeMember (payload);
    return response;
  },

  async list (context, payload) {
    var response = await API.company.list (payload);
    // set company in list
    context.commit ('set_list', {
      companies: response.companies.data,
    });
    return response;
  },

  async onAfterCreate (context, payload) {
    // router.push ({
    //   name: 'Subscription',
    //   params: {company_id: payload.company.id},
    // });
    router
      .push ({
        name: 'CompanyDashboard',
        params: {
          company_id: payload.company.id,
        },
      })
      .catch (err => {});

    let props = router.resolve ({
      name: 'CompanyProfile',
      params: {company_id: payload.company.id},
    });

    context.dispatch (
      'app/showMessage',
      {
        message: i18n.t ('company.save.success.message', {
          settingLink: props.href,
        }),
        color: DEFINES.SNACKBAR_SUCCESS_COLOR,
      },
      DEFINES.USE_ROOT
    );
  },

  async switchSelectedCompanyId (context, payload) {
    //reset old company data
    context.commit ('film/reset', null, DEFINES.USE_ROOT);

    //find and set company
    let company = await context.dispatch ('get', payload);
    // refresh company data in background
   // context.dispatch ('get', payload);

    context.commit ('set_selected', {
      selected_company_id: company.id,
    });
    //set films
    context.dispatch ('film/list', {}, DEFINES.USE_ROOT);
    //set screeners
    context.dispatch (
      'screener/list',
      {
        perPage: 30,
        schedule_type: 30,
      },
      DEFINES.USE_ROOT
    );
    //Resetting timezone
    momentTz.tz.setDefault ();
    context.commit ('set_company_timezone', {
      company: company,
    });
    //Push to billing page if not subscribed (if user is owner)
    let role_in_company = context.getters.userRoleInCompany (company.id);
    // if (!company.subscribed_once && role_in_company == DEFINES.ROLE_OWNER)
    //   router.push ({name: 'Subscription'});
  },
  async getRecentActivities (context, payload) {
    let response = await API.company.recentActivities (payload);
    context.commit ('set_recent_activities', {
      activities: response.activities,
    });
    return response;
  },

  async getGapiToken (context, payload) {
    var response = await API.company.getGapiToken (payload);
    return response;
  },
  async setGapiToken (context, payload) {
    var response = await API.company.setGapiToken (payload);
    return response;
  },
  async resetGapiToken (context, payload) {
    var response = await API.company.resetGapiToken (payload);
    return response;
  },

  async getMailchimpLists (context, payload) {
    var response = await API.company.getMailchimpLists (payload);
    return response;
  },

  async updatePaymentMethod (context, payload) {
    var response = await API.company.updatePaymentMethod (payload);
    context.commit ('update_company', {
      company: response.company,
    });
    return response;
  },

  async buyAddons (context, payload) {
    var response = await API.company.buyAddons (payload);
    if(response.company){
      context.commit ('update_company', {
        company: response.company,
      });
      //set selected company
      context.commit ('set_company', {
        company: response.company,
      });
    }
    return response;
  },

  async markAddonPurchased (context, payload) {
    var response = await API.company.markAddonPurchased (payload);
    context.commit ('update_company', {
      company: response.company,
    });
    //set selected company
    context.commit ('set_company', {
      company: response.company,
    });
    return response;
  },

  async listTransaction (context, payload) {
    var response = await API.company.listTransaction (payload);
    return response;
  },
  async generateNewOAuthSecret(context, payload){
    // Generate new oauth secret for organization
    let response = await API.company.generateNewOAuthSecret (payload);
    return response
  },

  async updateWhitelabelDomain (context, payload) {
    var response = await API.company.updateWhitelabelDomain (payload);
    return response;
  },

  async listPaymentGateways(context, payload){
    //get company payment gateways from API
    let response = await API.company.listPaymentGateways (payload);
    return response
  },
  async listSubscription (context, payload) {
    var response = await API.company.listSubscription (payload);
    return response;
  },
};
//getters
const getters = {
  getField,

  get: (state, getters, rootState) => {
    return state.company
   },

  getCompanies: (state, getters, rootState) => {
    return state.list;
  },
  getCompany: state => id => {
    return state.list.find (company => {
      return company.id == id;
    });
  },

  /** get Selected company */
  getSelectedCompany: (state, getters) => {
    var selected_company_id = getters['getSelected'];
    return state.list.find (company => company.id == selected_company_id);
  },

  userRoleInCompany: state => company_id => {
    var company = state.list.find (company => {
      return company.id == company_id;
    });
    return company ? company.pivot.role : null;
  },

  getSelected: state => state.selected_company_id,

  isCompanySubscribed: (state, getters) => {
    var selected_company = getters['getSelectedCompany'];
    if (selected_company) return selected_company.subscription;
  },

  isSubscriptionTrailingOrActive: (state, getters) => {
    var selectedCompany = getters['getSelectedCompany'];
    if (selectedCompany) {
      return selectedCompany.subscription_status
        ? selectedCompany.subscription_status <=
            DEFINES.SUBSCRIPTION_STATUS_ACTIVE
        : false;
    }
    return false;
  },

  getAvailLinkUrl: (state, getters) => payload => {
    return `${DEFINES.AVAIL_APP_URL}/company/${payload.company_id}/avail/link/${payload.uuid}`;
  },

  getSelectedCompanyTimezone (state, getters) {
    var selectedCompany = getters['getSelectedCompany'];
    if (
      selectedCompany &&
      selectedCompany.custom_properties &&
      selectedCompany.custom_properties.timezone
    ) {
      return selectedCompany.custom_properties.timezone;
    }
    return momentTz.tz.guess (true);
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.companies;
  },

  set_selected (state, payload, rootState) {
    state.selected_company_id = payload.selected_company_id;
  },

  set_members (state, payload, rootState) {
    state.members = payload.members;
  },

  set_company (state, payload) {
    // console.log ('Setting selected company');
    state.company = payload.company;
  },

  update_company (state, payload) {
    state.list = [
      ...state.list.filter (company => company.id !== payload.company.id),
      payload.company,
    ];
  },
  set_recent_activities (state, payload) {
    state.recent_activities = payload.activities.data;
  },

  set_avail_links (state, payload) {
    state.avail_links = payload.avail_links;
  },

  reset_selected_company (state) {
    state.company = null;
    state.selected_company_id = null;
  },

  set_company_timezone (state, payload) {
    let company = payload.company;
    // Setting timezone of the company
    if (company.custom_properties.timezone) {
      let tz_to_be_set = company.custom_properties.timezone;
      // console.log ('Setting timezone = ' + tz_to_be_set);
      momentTz.tz.setDefault (tz_to_be_set);
    }
  },
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
